import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'mojo-expandible-card',
  templateUrl: './mojo-expandible-card.component.html',
  styleUrls: ['./mojo-expandible-card.component.scss'],
})
export class MojoExpandibleCardComponent {
  @Input()
  isExpanded = false;

  @Input()
  expandable = true;

  @Input()
  noPadding = false;

  @Input()
  collapsedHeight;

  @Output()
  toggle: EventEmitter<boolean> = new EventEmitter<boolean>();

  toggleCard() {
    this.isExpanded = !this.isExpanded;
    this.toggle.emit(this.isExpanded);
  }
}
